import React from "react";
import Header from "./Header";
import PqrsdHub from "../pqrsd/PqrsdHub";

export default function LayoutPqrsdHub() {
  return (
    <>
      <Header />
      <PqrsdHub />
    </>
  );
}
